import React from 'react';
import { CssBaseline } from '@mui/material';
import { useTheme } from './context/themeContext';
import { PureLightTheme } from './theme/schemes/PureLightTheme';
import { DarkTheme } from './theme/schemes/DarkTheme';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

const ThemeWrapper = ({ children }) => {
  const { mode } = useTheme();
  const theme = React.useMemo(() => {
    return mode === 'dark' ? DarkTheme : PureLightTheme;
  }, [mode]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeWrapper;